import React from "react";
import "./detalleEmpleadoDatos.css";

function formatDate(raw) {
    if (!raw) return "-";

    let year, month, day;

    if (raw instanceof Date) {
        year = raw.getFullYear();
        month = raw.getMonth() + 1;
        day = raw.getDate();
    } else if (typeof raw === "string") {
        const isoDateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (isoDateOnly) {
            [, year, month, day] = isoDateOnly;
        } else if (/^\d{4}-\d{2}-\d{2}T/.test(raw)) {
            const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})T/);
            if (m) {
                [, year, month, day] = m;
            }
        } else {
            const d = new Date(raw);
            if (isNaN(d)) return raw;
            year = d.getFullYear();
            month = d.getMonth() + 1;
            day = d.getDate();
        }
    } else {
        const d = new Date(raw);
        if (isNaN(d)) return raw;
        year = d.getFullYear();
        month = d.getMonth() + 1;
        day = d.getDate();
    }

    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

export default function DetalleEmpleadoDatos({
    numeroEmpleado,
    curp,
    rfc,
    fechaNacimiento,
    numeroSeguroSocial,
    gradoEstudios,
    ingresoActual,
    egresoActual,
    tiempoTrabajado,
    activo,
    className = "",
}) {
    return (
        <div className={`detalle-empleado-datos mb-4 ${className}`}>
            <div className="info-grid">
                {/* Bloque personal */}
                <div className="info-group">
                    <div className="info-row">
                        <div className="label">No. Empleado:</div>
                        <div className="value">{numeroEmpleado}</div>
                    </div>
                    <div className="info-row">
                        <div className="label">CURP:</div>
                        <div className="value">{curp || "-"}</div>
                    </div>
                    <div className="info-row">
                        <div className="label">RFC:</div>
                        <div className="value">{rfc || "-"}</div>
                    </div>
                    <div className="info-row">
                        <div className="label">Fecha de nacimiento:</div>
                        <div className="value">{formatDate(fechaNacimiento)}</div>
                    </div>
                    <div className="info-row">
                        <div className="label">NSS:</div>
                        <div className="value">{numeroSeguroSocial || "-"}</div>
                    </div>
                    <div className="info-row">
                        <div className="label">Grado de estudios:</div>
                        <div className="value">{gradoEstudios || "-"}</div>
                    </div>
                </div>

                {/* Bloque laboral / estado */}
                <div className="info-group">
                    <div className="info-row">
                        <div className="label">Ingreso (actual):</div>
                        <div className="value">
                            <span className="badge info">{ingresoActual || <span className="empty">-</span>}</span>
                        </div>
                    </div>
                    <div className="info-row">
                        <div className="label">Egreso (actual):</div>
                        <div className="value">
                            <span className="badge warning">{egresoActual || <span className="empty">-</span>}</span>
                        </div>
                    </div>
                    <div className="info-row">
                        <div className="label">Tiempo (periodo actual):</div>
                        <div className="value">
                            <span className="badge dark">{tiempoTrabajado}</span>
                        </div>
                    </div>
                    <div className="info-row status-row">
                        <div className="label">Activo:</div>
                        <div className="value">
                            {activo ? (
                                <span className="badge success">Sí</span>
                            ) : (
                                <span className="badge danger">No</span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
